import React from "react"

export const Movie = () => {
  const videoId = "0f26e49b-bb66-4829-9dc1-8ccca931ebd5"
  return (
    <div
      style={{
        position: "relative",
        height: 400,
        width: "100%"
        //  paddingTop: "56.25%", height: "100%"
      }}
    >
      <iframe
        title="Film de mariage"
        src={`https://player.mediadelivery.net/embed/548728/${videoId}?autoplay=false&loop=false&muted=false&preload=true&responsive=true`}
        loading="lazy"
        style={{
          border: "0",
          position: "absolute",
          top: "0",
          left: "0",
          height: "100%",
          width: "100%"
        }}
        allow="accelerometer;gyroscope;encrypted-media;picture-in-picture;"
        allowFullScreen
      />
    </div>
  )
}
